/**
 *  Users.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import { Grid, Tabs, Tab } from "react-bootstrap";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { clearUsers } from "../../actions/users";

// components
import AlertsList from "./AlertsList.jsx";

// style
import "./style.css";

// global
var firebase = require("../../firebase");

class Alerts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
    };
  }

  componentWillMount() {
    document.title = "Security Care | Avisos";

    this.getData();
  }

  componentWillUnmount() {
    firebase.database.ref("warnings").off();
  }

  getData = () => {
    firebase.database.ref("warnings").on("child_added", (snap) => {
      const { users } = this.props;
      const { list } = this.state;
      let newList = [];
      let warning = snap.val();
      warning["key"] = snap.key;
      warning["user"] = users[snap.key];
      newList.push(warning);
      for (const i in list) {
        newList.push(list[i]);
      }
      this.setState({ list: newList });
    });

    firebase.database.ref("warnings").on("child_removed", (snap) => {
      const { list } = this.state;
      let newList = [];
      let removeIdx = -1;
      for (const idx in list) {
        if (list[idx].key != snap.key) {
          newList.push(list[idx]);
        }
      }
      this.setState({ list: newList });
    });
  };

  render() {
    const { list } = this.state;

    return (
      <div className="content bg-content">
        <Grid fluid>
          <Tabs defaultActiveKey="0" id="uncontrolled-tab-example">
            <Tab eventKey="0" title={`USUÁRIOS (${list.length})`}>
              <AlertsList list={list} />
            </Tab>
          </Tabs>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  users: store.users.users,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ clearUsers }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);



// WEBPACK FOOTER //
// ./src/views/Alerts/Alerts.jsx